import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZAsset = z.object({
  id: z.string(),
  name: z.string(),
  assetType: z.optional(z.string())
})

const ZDevice = z.object({
  id: z.string(),
  name: z.string(),
  deviceTypeId: z.string()
})

const ZApiResponse = z.object({
  error: z.boolean(),
  http_status: z.number(),
  data: z.object({
    total_count: z.number(),
    site_id: z.string(),
    assets: z.array(ZAsset).optional(),
    devices: z.array(ZDevice).optional()
  }).nullable()
})

export type Asset = z.infer<typeof ZAsset>
export type Device = z.infer<typeof ZDevice>

// istanbul ignore next
export async function fetchAssetsAndDevices (
  siteId: string,
  onSuccess: (data: { assets?: Asset[], devices?: Device[] }, httpStatus: number) => any,
  onFailure: (errorMessage: any, httpStatus: number) => any,
  assetId?: string
): Promise<void> {
  const url = `/assetrest/api/v2/udp/tiq/assets/getAssetsAndDevices?siteId=${siteId}` + ((assetId != null) ? `&assetId=${assetId}` : '') + '&page=0&size=100'

  interceptedAxios
    .get(url, { timeout: 15000 })
    .then((response: any) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // istanbul ignore else
      if (parseResponse.success) {
        // istanbul ignore else
        if (parseResponse.data.data !== null && parseResponse.data.data !== undefined) {
          onSuccess(parseResponse.data.data, response.status)
        } else {
          onFailure(parseResponse.data.error, response.status)
        }
      } else {
        onFailure(parseResponse.error.message, response.status)
      }
    })
    .catch((error: any) => {
      onFailure(error.message, error.response.status)
    })
}
